import Card from "components/card";
import { RiErrorWarningFill } from "react-icons/ri";
const Widget = ({ icon, title, subtitle, loading = false, error = null }) => {
  return (
    <Card extra="!flex-row flex-grow items-center rounded-[20px]">
      <div className="ml-[18px] flex h-[90px] w-auto flex-row items-center">
        <div className="rounded-full bg-lightPrimary p-3 dark:bg-navy-700">
          <span className="flex items-center text-brand-500 dark:text-white">
            {icon}
          </span>
        </div>
      </div>

      <div className="h-50 ml-4 flex w-auto flex-col justify-center">
        <p className="font-dm text-sm font-medium text-gray-600">{title}</p>
        {loading ? (
          <div className="mt-1 h-6 w-10 animate-pulse rounded-md bg-gray-100 dark:bg-navy-700"></div>
        ) : error ? (
          <div className="flex items-center gap-2 text-red-500">
            <RiErrorWarningFill className="h-4 w-4" />
          </div>
        ) : (
          <h4 className="text-xl font-bold text-navy-700 dark:text-white">
            {subtitle}
          </h4>
        )}
      </div>
    </Card>
  );
};

export default Widget;
